(function () {
  document.querySelectorAll('[data-be-header]').forEach(function (root) {
    var drawer = root.querySelector('.be-store__drawer');
    var burger = root.querySelector('.be-store__burger');
    var searchPanel = root.querySelector('[data-be-search]');
    var searchInput = root.querySelector('#be-search-input');
    var searchOpeners = root.querySelectorAll('[data-be-search-open]');
    var cargoPanel = root.querySelector('[data-be-cargo]');
    var cargoOpeners = document.querySelectorAll('[data-be-cargo-open]');
    var cargoInput = root.querySelector('#be-cargo-order');

    function openDrawer() {
      if (!drawer) return;
      closeCargo();
      closeSearch();
      resetDrawerSubView(drawer);
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      if (!drawer) return;
      resetDrawerSubView(drawer);
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      if (!searchPanel || !searchPanel.classList.contains('is-open')) {
        document.body.style.overflow = '';
      }
    }

    function resetDrawerSubView(drawerEl) {
      var main = drawerEl.querySelector('[data-be-drawer-main]');
      var subview = drawerEl.querySelector('[data-be-drawer-subview]');
      var subList = drawerEl.querySelector('[data-be-drawer-sub-list]');
      if (main) main.hidden = false;
      if (subview) subview.hidden = true;
      if (subList) subList.innerHTML = '';
    }

    function initDrawerSubViews(drawerEl) {
      var main = drawerEl.querySelector('[data-be-drawer-main]');
      var subview = drawerEl.querySelector('[data-be-drawer-subview]');
      var subList = drawerEl.querySelector('[data-be-drawer-sub-list]');
      var backBtn = drawerEl.querySelector('[data-be-drawer-sub-back]');
      var backLabel = drawerEl.querySelector('[data-be-drawer-sub-back-label]');

      drawerEl.querySelectorAll('[data-be-drawer-open-sub]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var cell = btn.closest('.be-store__drawer-cell');
          var subs = cell && cell.querySelector('[data-be-drawer-subs]');
          if (!subs || !subList || !subview || !main) return;
          var titleEl = btn.querySelector('.be-store__drawer-card-title');
          var title = titleEl ? titleEl.textContent.trim() : ((window.beStrings && window.beStrings.categories) || 'Categories');
          subList.innerHTML = subs.innerHTML;
          if (backLabel) backLabel.textContent = title;
          main.hidden = true;
          subview.hidden = false;
        });
      });

      if (backBtn) {
        backBtn.addEventListener('click', function () {
          resetDrawerSubView(drawerEl);
        });
      }
    }

    function closeWishlistDrawer() {
      document.querySelectorAll('[data-be-wishlist-drawer].is-open').forEach(function (panel) {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
      });
      document.querySelectorAll('[data-be-wishlist-open]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    }

    function openSearch() {
      if (!searchPanel) return;
      closeWishlistDrawer();
      closeCargo();
      closeDrawer();
      searchPanel.classList.add('is-open');
      searchPanel.setAttribute('aria-hidden', 'false');
      searchOpeners.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'true');
      });
      document.body.style.overflow = 'hidden';
      window.setTimeout(function () {
        if (searchInput) searchInput.focus();
      }, 120);
    }

    function closeSearch() {
      if (!searchPanel) return;
      searchPanel.classList.remove('is-open');
      searchPanel.setAttribute('aria-hidden', 'true');
      searchOpeners.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
      if (!drawer || !drawer.classList.contains('is-open')) {
        document.body.style.overflow = '';
      }
    }

    if (burger) {
      burger.addEventListener('click', function () {
        closeWishlistDrawer();
        openDrawer();
      });
    }

    if (drawer) {
      initDrawerSubViews(drawer);

      drawer.querySelectorAll('[data-be-close]').forEach(function (el) {
        el.addEventListener('click', closeDrawer);
      });
    }

    searchOpeners.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (searchPanel && searchPanel.classList.contains('is-open')) {
          closeSearch();
        } else {
          openSearch();
        }
      });
    });

    if (searchPanel) {
      searchPanel.querySelectorAll('[data-be-search-close]').forEach(function (el) {
        el.addEventListener('click', closeSearch);
      });
    }

    function closeCargo() {
      if (!cargoPanel) return;
      cargoPanel.classList.remove('is-open');
      cargoPanel.setAttribute('aria-hidden', 'true');
      cargoOpeners.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
      if ((!drawer || !drawer.classList.contains('is-open')) && (!searchPanel || !searchPanel.classList.contains('is-open'))) {
        document.body.style.overflow = '';
      }
    }

    function openCargo() {
      if (!cargoPanel) return;
      closeWishlistDrawer();
      closeDrawer();
      closeSearch();
      cargoPanel.classList.add('is-open');
      cargoPanel.setAttribute('aria-hidden', 'false');
      cargoOpeners.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'true');
      });
      document.body.style.overflow = 'hidden';
      window.setTimeout(function () {
        if (cargoInput) cargoInput.focus();
      }, 120);
    }

    cargoOpeners.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (cargoPanel && cargoPanel.classList.contains('is-open')) {
          closeCargo();
        } else {
          openCargo();
        }
      });
    });

    if (cargoPanel) {
      cargoPanel.querySelectorAll('[data-be-cargo-close]').forEach(function (el) {
        el.addEventListener('click', closeCargo);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (cargoPanel && cargoPanel.classList.contains('is-open')) {
        closeCargo();
        return;
      }
      if (searchPanel && searchPanel.classList.contains('is-open')) {
        closeSearch();
      }
    });

    function onScroll() {
      if (window.scrollY > 24) {
        root.classList.add('is-scrolled');
      } else {
        root.classList.remove('is-scrolled');
      }
    }

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    preservePreviewLinks(root);
  });

  function preservePreviewLinks(root) {
    var previewParams = ['preview_theme_id', '_fd', 'pb', 'view'];
    var current = new URLSearchParams(window.location.search);
    var hasPreview = previewParams.some(function (key) {
      return current.has(key);
    });
    if (!hasPreview) return;

    root.querySelectorAll('[data-be-cart-link], a[href*="/cart"]').forEach(function (link) {
      try {
        var url = new URL(link.href, window.location.origin);
        previewParams.forEach(function (key) {
          var value = current.get(key);
          if (value) url.searchParams.set(key, value);
        });
        link.href = url.pathname + url.search + url.hash;
      } catch (e) {}
    });
  }
})();
